// data-testid registry
export const IDS = {
  landing: {
    root: "landing-page",
    ctaSignup: "landing-cta-signup",
    ctaLogin: "landing-cta-login",
    heroTitle: "landing-hero-title",
    featureVoice: "landing-feature-voice",
    featureFlow: "landing-feature-flow",
    featureCurrency: "landing-feature-currency",
  },
  auth: {
    loginPage: "login-page",
    emailInput: "login-email-input",
    passwordInput: "login-password-input",
    submitBtn: "login-submit-btn",
    switchModeBtn: "login-switch-mode",
    nameInput: "login-name-input",
    googleBtn: "login-google-btn",
    logoutBtn: "logout-btn",
  },
  nav: {
    sidebar: "app-sidebar",
    linkDashboard: "nav-link-dashboard",
    linkQuotes: "nav-link-quotes",
    linkSettings: "nav-link-settings",
    linkNewQuote: "nav-link-new-quote",
    notifBell: "nav-notification-bell",
  },
  onboarding: {
    page: "onboarding-page",
    nameInput: "onboarding-business-name",
    currencySelect: "onboarding-currency-select",
    taxInput: "onboarding-default-tax",
    submitBtn: "onboarding-submit",
    phoneInput: "onboarding-phone",
    addressInput: "onboarding-address",
  },
  dashboard: {
    page: "dashboard-page",
    statTotal: "dashboard-stat-total",
    statAccepted: "dashboard-stat-accepted",
    statPending: "dashboard-stat-pending",
    statRevenue: "dashboard-stat-revenue",
    recentQuotes: "dashboard-recent-quotes",
  },
  quotes: {
    listPage: "quotes-list-page",
    row: (id) => `quote-row-${id}`,
    newBtn: "quotes-new-btn",
    filterAll: "quotes-filter-all",
    filterDraft: "quotes-filter-draft",
    filterSent: "quotes-filter-sent",
    filterAccepted: "quotes-filter-accepted",
    filterDeclined: "quotes-filter-declined",
    filterModRequested: "quotes-filter-mod",
  },
  editor: {
    page: "quote-editor-page",
    voiceBtn: "quote-editor-voice-btn",
    voiceStop: "quote-editor-voice-stop",
    transcriptBox: "quote-editor-transcript",
    parseBtn: "quote-editor-parse-btn",
    customerName: "quote-editor-customer-name",
    customerEmail: "quote-editor-customer-email",
    title: "quote-editor-title",
    description: "quote-editor-description",
    addLineItem: "quote-editor-add-line-item",
    lineItem: (i) => `quote-editor-line-${i}`,
    lineItemDesc: (i) => `quote-editor-line-${i}-desc`,
    lineItemQty: (i) => `quote-editor-line-${i}-qty`,
    lineItemPrice: (i) => `quote-editor-line-${i}-price`,
    lineItemRemove: (i) => `quote-editor-line-${i}-remove`,
    taxInput: "quote-editor-tax",
    currencySelect: "quote-editor-currency",
    saveBtn: "quote-editor-save-btn",
    sendBtn: "quote-editor-send-btn",
    saveVersionBtn: "quote-editor-save-version-btn",
    subtotal: "quote-editor-subtotal",
    total: "quote-editor-total",
    terms: "quote-editor-terms",
    depositToggle: "quote-editor-deposit-toggle",
    depositPct: "quote-editor-deposit-pct",
    photoInput: "quote-editor-photo-input",
    photoItem: (id) => `quote-editor-photo-${id}`,
    photoRemove: (id) => `quote-editor-photo-remove-${id}`,
    photoCaption: (id) => `quote-editor-photo-caption-${id}`,
    photoCaptionInput: (id) => `quote-editor-photo-caption-input-${id}`,
    photoCaptionSave: (id) => `quote-editor-photo-caption-save-${id}`,
    photoCaptionRegen: (id) => `quote-editor-photo-caption-regen-${id}`,
  },
  detail: {
    page: "quote-detail-page",
    publicLinkCopy: "quote-detail-copy-link",
    editBtn: "quote-detail-edit-btn",
    sendBtn: "quote-detail-send-btn",
    statusBadge: "quote-detail-status",
    responsesList: "quote-detail-responses",
  },
  publicQuote: {
    page: "public-quote-page",
    acceptBtn: "public-quote-accept-btn",
    modifyBtn: "public-quote-modify-btn",
    declineBtn: "public-quote-decline-btn",
    stickyBar: "public-quote-sticky-bar",
    acceptConfirmName: "public-quote-accept-name",
    acceptConfirmSubmit: "public-quote-accept-submit",
    modifyFeedback: "public-quote-modify-feedback",
    modifySubmit: "public-quote-modify-submit",
    declineReason: "public-quote-decline-reason",
    declineSubmit: "public-quote-decline-submit",
    currencySelect: "public-quote-currency-select",
    depositBanner: "public-quote-deposit-banner",
    depositPayBtn: "public-quote-deposit-pay-btn",
    schedulerDate: "public-quote-scheduler-date",
    schedulerSubmit: "public-quote-scheduler-submit",
    photoGallery: "public-quote-photo-gallery",
    photoCaption: (id) => `public-quote-photo-caption-${id}`,
  },
  dashboardExtra: {
    statWinRate: "dashboard-stat-win-rate",
    statAvgTime: "dashboard-stat-avg-time",
    statDeposits: "dashboard-stat-deposits",
  },
  settings: {
    page: "settings-page",
    saveBtn: "settings-save-btn",
  },
};
